import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output, inject } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../base/base.component';
import { LocalRepository } from '@shared/helper/local-repository';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FileService } from '@shared/service/http_services/file.service';

import { CustomeCropperComponent } from '../dialogs/custome-cropper/custome-cropper.component';
import { MatButtonModule } from '@angular/material/button';
import { ECropperImageType } from '../dialogs/custome-cropper/models/cropper.enum';
import { ICropperConfig } from '@shared/model/general/cropper-config.model';
import { SnackBarTypes } from '../cutome-snack-bar/custome-snack-bar.component';


@Component({
    selector: 'app-behkhaan-suggestion-set-avatar',
    templateUrl: './behkhaan-suggestion-set-avatar.component.html',
    styleUrls: ['./behkhaan-suggestion-set-avatar.component.scss'],
    imports: [
        CommonModule,
        MatButtonModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BehkhaanSuggestionSetAvatarComponent extends BaseComponent {
  private _dialog = inject(MatDialog);
  private cdr = inject(ChangeDetectorRef);
  private fileService = inject(FileService);
  private _localRepository = inject(LocalRepository);


  @Output() close: EventEmitter<closeSuggestionEnum> = new EventEmitter<closeSuggestionEnum>();

  dialogRef!: MatDialogRef<CustomeCropperComponent, any>;
  loadingSetAvatar!: boolean;
  recivedResult!: any;
  uploadingAvatar!: boolean;
  uploadingBanner!: boolean;
  recivedImage!: any;
  uploadableImage!: string;
  userCurrentAvatarSrc = '';



  constructor() {
    super();
  }

  closeSuggestion() {
    this.close.emit(closeSuggestionEnum.userClosed);
  }

  uploadAvatar() {
    this.loadingSetAvatar = true;
    if (!this._localRepository.IsInBrowser) return;

    this.dialogRef = this._dialog.open(CustomeCropperComponent, {
      panelClass: 'cropper-container',
      data: {
        aspect_ratio: ECropperImageType.circle_350,
        fromQuote: false,
        fileType: 'users_avatars'
      } as ICropperConfig
    });

    this.subscriptions.push(
      this.dialogRef.afterClosed().pipe(
        tap(result => {
          if (result != undefined) {
            this.userCurrentAvatarSrc = result.croppedImageData;
          }
          this.uploadableImage = result.base64;
        }),
        switchMap(() => this.fileService.uploadFile(this.uploadableImage, 'avatars', this.currentUser?.id!))
      ).subscribe(res => {
        this.loadingSetAvatar = false;
        if (!res.hasError && res.result) {
          this.fileService.userImage_$.next(this.userCurrentAvatarSrc);
          this.snackbarService.openSnackbar(SnackBarTypes.success, 'تصویر شما با موفقیت ثبت شد.' );
          this.close.emit(closeSuggestionEnum.uploaded);
        }
        else {
          this.snackbarService.openSnackbar(SnackBarTypes.success, 'متاسفانه ثبت تصویرتان با مواجه مشکل شد.' );
          this.userCurrentAvatarSrc = '';
        }
      })
    );
  }
}

export enum closeSuggestionEnum {
  uploaded = 1,
  userClosed
}

